import React from 'react';
import { motion } from 'framer-motion';
import ProjectCard from './ProjectCard';
import Projects from '../Constants/Projects';

const Work = () => {
  return (
    <section id="Work" className="section-wrap">
      <div className="section-header">
        <p className="eyebrow">Portfolio</p>
        <h2 className="section-title">Selected Projects</h2>
      </div>

      <div className="project-grid">
        {Projects.map((project, index) => (
          <motion.div
            key={`project-${project.title}`}
            initial={{ opacity: 0, y: 22 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: index * 0.08, ease: 'easeOut' }}
            viewport={{ once: true, amount: 0.2 }}
          >
            <ProjectCard
              tags={project.tags}
              title={project.title}
              description={project.description}
              url={project.url}
              thumbnail={project.thumbnail}
            />
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Work;
